import { h, Component } from 'preact';
import { Link } from 'preact-router/match';

const style = require('./style');

export default class NotFound extends Component<any,any> {
    componentDidMount() {
        fetch('/api/1/counters/increment/notfound', { method: 'POST' });
    }

    render() {
        return (
            <div class={style.message}>
                <img src="/assets/ga.png?2" class={style.logo}
                    alt="Geeks Anonymous - If only everything came with pulldown menus and online help."
                />

                <h1>Page Not Found</h1>
                <p>The specified file was not found on this website. Please check the URL for mistakes and try again.</p>

                <h3>Why am I seeing this?</h3>
                <p>Probably because the main website for <i>geeksanon.ca</i> has been offline for quite a long time and none of the original content still exists.</p>

                <Link activeClassName="" href="/">Try the main page</Link>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./routes/notfound/index.tsx